const Cookies = require('js-cookie');
import firebase from "firebase/app";
import "firebase/auth";
import { ApiService } from './api-service.js';
import { AnalyticsService } from './analytics-service.js';

export interface AuthService {
  onAuthStateChanged(callback: (user: any) => void):void;
  getUser(): Promise<any>;
  // reauthenticate():void;
  login():void;
  logout(): Promise<any>;
}

export class FireBaseAuthService implements AuthService {
  private authStateHandlers: Array<any> = [];
  private provider = new firebase.auth.OAuthProvider('yahoo.com');
  private userCreds?: firebase.auth.UserCredential;

  constructor(private apiService: ApiService, private analyticsService: AnalyticsService) {
    this.provider.addScope("fspt-r");
    this.provider.addScope("email");
    this.provider.setCustomParameters({
      response_type: 'code',
    });

    firebase.auth().onAuthStateChanged((user) => {
      this.authStateHandlers.forEach(h => h(user));
    })

    /*
    This is called when we land back on our website, 3 things could happen:
    (1) we're being redirected from yahoo, and so result is going to have the credentials we need
    (2) we're here by ourselves, and so result is going to be `undefined`, and we need to grab yahoo tokens from cookie
    (3) we're here by ourselves, and so result is going to be `undefined`, and we need to grab yahoo tokens from cookie BUT we don't have any cookies YET
    */

    firebase.auth().getRedirectResult()
      .then((result) => {
        this.userCreds = result;
        const currentUser = firebase.auth().currentUser
        if(currentUser) {
          
          //Testing for scenario (3), in case we need to force a relogin
          const cookie = JSON.parse(Cookies.get('fc_cr') || '{}');
          if(!cookie && !result.credential) {
            this.login()
          }

          this.setUser(currentUser, this.userCreds).then(() => {
             //Can probably get rid of this getManager call here
            // this.apiService.getManager()
            this.analyticsService.logEvent('auth_success')
          });
        }
        else {
          //TODO no user: do something here?
        }
      })
      .catch(function (error) {
        // Handle error
        console.error("getRedirectResult error", error)
      })

      //subscribing to auth change to set the new token
      firebase.auth().onIdTokenChanged(user => {
        if (user) {
         this.setUser(user, this.userCreds).then(() => {
           this.analyticsService.logEvent('token_refresh_success')
         })
        }
      })
  }

  setUser(user: firebase.User, creds?: firebase.auth.UserCredential) : Promise<string | void> {
    return user.getIdToken(false).then((idToken) => {
      const cookie = JSON.parse(Cookies.get('fc_cr') || '{}');
      //Testing for scenario (3), in case we need to force a relogin
      
      //prioritizing scenario (1): if we have new yahoo credentials, they'll be updated in the cookie
      //not sure why linter not handling creds?.credential
      const yahooAccessToken = creds && creds.credential ? (creds.credential as any).accessToken: cookie.yahoo_access_token;
      const yahooIdToken =creds && creds.credential ? (creds.credential as any).idToken : cookie.yahoo_id_token;

      //persisting new credentials for later retrieval
      Cookies.set('fc_cr', JSON.stringify({
        "yahoo_access_token": yahooAccessToken,
        "yahoo_id_token": yahooIdToken,
        "firebase_id_token" : idToken
      }),  { sameSite: 'strict' });

      this.apiService.setCredentials(yahooAccessToken, yahooIdToken, idToken)
    })
  }

  getUser(): Promise<any> {
    return new Promise((resolve, reject) => {
      const unsub = firebase.auth().onAuthStateChanged((user) => {
        unsub();
        resolve(user)
      });
    });
  }


  // reauthenticate() {
  //   const currentUser = firebase.auth().currentUser
  //   if (currentUser) {
  //     currentUser.reauthenticateWithRedirect(this.provider)
  //   }
  // }

  login () {
    this.analyticsService.logEvent('auth_started')
    firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL)
      .then(() => {
        firebase.auth().signInWithRedirect(this.provider)
      })
      .catch((error) => {
       this.analyticsService.logEvent('auth_error')
        // var errorCode = error.code;
        // var errorMessage = error.message;
      });
  }
  logout () {
    this.analyticsService.logEvent('auth_logout')
    return new Promise((resolve, reject) => {
      firebase.auth().signOut().then(() => {
        resolve(true);
      })
    });
  }
  onAuthStateChanged(callback: (user: any) => void) : void {
    this.authStateHandlers.push(callback);
  }
}
